/**
 * Build-time / env-only config. Anything Paul might want to edit lives in the
 * site-settings Payload global (see src/lib/site-settings.ts) with the env
 * value as the field's defaultValue. Only put things here that cannot live
 * in Payload because they need to be available at module load (analytics IDs,
 * site URL for metadata building, third-party site keys).
 */
export const siteUrl = process.env.NEXT_PUBLIC_SITE_URL ?? 'https://rocknearthworks.com.au'

// Every tracking id is empty anywhere but the production deployment. A preview
// once reported two synthetic leads into the live GA4 property because the id
// used to fall back to the real one. NEXT_PUBLIC_DEPLOY_ENV is inlined by
// next.config.mjs from VERCEL_ENV alone, so server and client agree and a stray
// NEXT_PUBLIC_VERCEL_ENV in the scope can't switch tracking on.
export const trackingEnabled = process.env.NEXT_PUBLIC_DEPLOY_ENV === 'production'

export const gaId = trackingEnabled ? (process.env.NEXT_PUBLIC_GA_ID ?? 'G-3J7YN5Z3VN') : ''
// Google Ads conversion tracking. Only .env.production sets it.
export const googleAdsId = trackingEnabled ? (process.env.NEXT_PUBLIC_GOOGLE_ADS_ID ?? '') : ''

// Social media URLs (used as defaults in the navigation global; kept here too
// because the navigation getter reads them at field-default time)
export const facebookUrl = process.env.NEXT_PUBLIC_FACEBOOK_URL ?? ''
export const instagramUrl = process.env.NEXT_PUBLIC_INSTAGRAM_URL ?? ''
export const tiktokUrl = process.env.NEXT_PUBLIC_TIKTOK_URL ?? ''
export const youtubeUrl = process.env.NEXT_PUBLIC_YOUTUBE_URL ?? ''
export const googleReviewsUrl = process.env.NEXT_PUBLIC_GOOGLE_REVIEWS_URL ?? ''

// Third-party integrations (build-time keys, never CMS-managed)
export const googleVerification = process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION ?? ''
export const metaPixelId = trackingEnabled ? (process.env.NEXT_PUBLIC_META_PIXEL_ID ?? '') : ''
export const tiktokPixelId = trackingEnabled ? (process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID ?? '') : ''
